module.exports = __webpack_public_path__ + "static/media/lightbulb-slash.79b04645.svg";